import React from 'react';

export type inputOptions = {
  name: string;
  value: number | string;
  unavailableText?: string;
  element?: HTMLInputElement;
}

const TabContext = React.createContext<{
  createRef: (ref: any, tabIndex: number) => void;
  onFocus: (options: inputOptions) => void;
  onBlur: (options: inputOptions) => void;
  onClick: (element: any) => void;
  // onChange: (options: inputOptions) => void;
  onNext: (event?: any) => void;
  maxLength?: number;
  unavailableText?: string;
  border?: boolean;
}>({
  createRef() { },
  onFocus() { },
  // onChange() {},
  onNext() { },
  onBlur() { },
  onClick() { }
});

export default TabContext;